import { TemplateResult, html, CSSResultGroup } from 'lit';
import { property, query } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../BlocksElement';
import '../button/button';
import styles from './pagination-item.styles';

/**
 * @slot default - The component content
 * @csspart base - The component's base wrapper.
 * @csspart link - The component's link.
 * @csspart part-default - The component's default slot.
 */
export class BlocksPaginationItem extends BlocksElement {static styles: CSSResultGroup = styles;

  /**
   * The text of the item link
   */
  @property({ type: String })
  text: string | undefined;

  /**
   * Divide adds a divider in between items to show that it's not orderd (e.g. item with 5 and then next item is 22)
   */
  @property({ type: Boolean })
  divide: boolean | undefined;

  /**
   * Disabled item
   */
  @property({ type: Boolean })
  disabled: boolean | undefined;

  /**
   * Active class for current item
   */
  @property({ type: Boolean })
  isActive: boolean | undefined;

  /**
   * Aria label to get announcement for label/Text in pagination-item
   */
  @property({ type: String })
  arialabel: string | undefined;

  /**
   * property to differentiate between previous/next button and more option as ellipsis
   */
  @property({ type: String })
  navigationType: 'ellipsis' | undefined;

  @query('.cat-c-pagination__item-button')
  private paginationItemButton!: HTMLButtonElement;

  override focus(options?: FocusOptions) {
    this.paginationItemButton.focus(options);
  }

  render(): TemplateResult<1> {
    const componentClassNames = this.componentClassNames('cat-c-pagination__item', {
      'cat-is-active': this.isActive === true
    });

    return html`
      <li part="base" class="${componentClassNames}">
        ${this.navigationType !== 'ellipsis'
          ? html` <cat-button
              part="pagination-item-button"
              variant="ghost"
              size="sm"
              ?disabled=${this.disabled}
              label=${ifDefined(this.arialabel)}
              role="presentation"
              ?currentStateIndicator=${this.isActive}
              class="cat-c-pagination__item-button"
            >
              <slot part="part-default"></slot>
            </cat-button>`
          : html`<slot part="part-default"></slot>`}
      </li>
    `;
  }
}

if (customElements.get('cat-pagination-item') === undefined) {
  customElements.define('cat-pagination-item', BlocksPaginationItem);
}

declare global {
  interface HTMLElementTagNameMap {
    'cat-pagination-item': BlocksPaginationItem;
  }
}
